<template>
  <div>
    <!-- BREADCRUMB -->
    <breadcrumb-base :breadcrumb="breadcrumb" :title="'Devices'">
      <template v-slot:right-end>
        <div class="vx-row my-5 mx-3 flex" style="place-items: end;">
          <div class="vx-col">
            <dynamic-customers-drop-down
              :placeholder="$t('SearchCustomer')"
              @on-item-selected="onCustomerChanged($event)">
            </dynamic-customers-drop-down>
          </div>
          <div v-if="activeUserInfo.account_role == 0" class="vx-col mt-5">

            <vs-button @click="openAddDevice" type="filled" icon-pack="feather"
                       icon="icon-plus">{{ $t('AddDevice') }}
            </vs-button>
          </div>
        </div>
      </template>
    </breadcrumb-base>

    <!-- Error List State-->
    <transition name="fade">
      <div class="py-6 flex w-full bg-img" v-if="errorFetching">
        <div
          class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
          <img src="@/assets/images/pages/svg_error.svg" :alt="$t('NoData')"
               class="mx-auto mb-4 max-w-full">
          <h1 class="sm:mx-0 mx-4 mb-12 text-3xl">{{ $t('ErrorData') }}</h1>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div class="vx-row">
        <div class="w-full">
          <!-- Empty List State -->
          <transition name="fade">
            <div class="h-screen flex w-full bg-img" v-if="devices.length === 0 && !errorFetching">
              <div
                class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
<!--                <img src="@/assets/images/pages/svg_blank.svg" :alt="$t('NoData')"-->
<!--                     class="mx-auto mb-4 max-w-full">-->
                <h1 class="sm:mx-0 mx-4 mb-12 text-3xl">{{ $t('NoData') }}</h1>
              </div>
            </div>
          </transition>
          <vs-table-modified v-show="devices.length > 0 && !errorFetching" ref="table"
                             :max-items="itemsPerPage" search
                             :data="devices">

            <template slot="thead">
              <vs-th>{{ $t('SNO') }}</vs-th>
              <vs-th >{{ $t('CustomerID') }}</vs-th>
              <vs-th >{{ $t('Organisation') }}</vs-th>
              <vs-th >{{ $t('DeviceSerialNo') }}</vs-th>
              <vs-th >{{ $t('DeviceStatus') }}</vs-th>
              <vs-th >{{ $t('DeviceLastUpdated') }}</vs-th>
              <vs-th>{{ $t('Action') }}</vs-th>
            </template>
            <template slot-scope="{data}">
              <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                <vs-td>
                  <p class="user-name font-medium truncate">{{ indextr + 1 }}</p>
                </vs-td>
                <vs-td>
                  <div class="vs-col">
                    <p class="user-name font-medium truncate">{{ tr.customer_id }}</p>
                    <p class="product-name font-medium truncate">{{ tr.organisation | capitalize }}</p>
                  </div>
                </vs-td>
                <vs-td>
                  <div class="vs-col">
                    <p class="truncate">{{ tr.organisation_first_name }} {{ tr.organisation_last_name }}</p>
                    <p style="font-size: 11px;">
                      {{ tr.address }}<span v-if="tr.house_no"> {{ tr.house_no }}</span>
                    </p>
                    <p style="font-size: 11px;">
                      {{ tr.postal }} {{ tr.city }}
                    </p>
                  </div>
                </vs-td>

                <vs-td>
                  <p class="user-name font-medium truncate">{{ tr.serial_no }}</p>
                </vs-td>


                <vs-td>
                  <div class="text-center flex justify-center">
                    <vs-chip :color="getStatusColor(tr)" class="user-status">{{
                        getStatusText(tr) | title
                      }}
                    </vs-chip>
                  </div>
                </vs-td>

                <vs-td>
                  <p class="user-name font-medium truncate">{{ tr.updated | dateFormat }}</p>
                </vs-td>

                <vs-td class="whitespace-no-wrap vx-row">
                  <vs-button class="" type="border" @click="openEditDevice(tr)">{{ $t('Edit') }}</vs-button>
                  <!--              <div class="px-2"></div>-->
                  <vs-button class="ml-2" type="border" :color="getInvertStatusColor(tr.status)"
                             @click="updateDeviceStatus(tr)">{{ tr.status === 1 ? $t('Deactivate') : $t('Activate') }}
                  </vs-button>
                </vs-td>

              </vs-tr>
              </tbody>
            </template>
            <template slot="footer">
            </template>
            <template slot="footer-left">
              <div class="flex">
                <vs-new-pagination :total="vTotalPages" v-model="cPage" v-on:change="listPageChanged">
                </vs-new-pagination>
              </div>
            </template>
          </vs-table-modified>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import DynamicCustomersDropDown from '@/views/pages/superadmin/customer/DynamicCustomersDropDown'

export default {
  name: 'ViewDevices',
  components: {
    DynamicCustomersDropDown,
  },
  data() {
    return {
      customer: null,
      cPage: 1,
      itemsPerPage: 20,
      isMounted: false,
      errorFetching: false,
      breadcrumb: [
        { title: 'Home', i18n: 'Home', url: '/' },
        { title: 'Devices', i18n: 'Devices', active: true },
      ],
    }
  },
  computed: {
    devices() {
      return this.$store.state.devices.devices
    },
    vPage() {
      return this.$store.state.devices.vPage
    },
    vTotalPages() {
      return this.$store.state.devices.vTotalPages
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
  },
  methods: {
    onCustomerChanged(c) {
      this.customer = c
      this.fetchDevices()
    },
    openEditDevice(data) {
      this.$router.push({ name: 'device-edit', params: { data: btoa(JSON.stringify(data)) } })
    },
    openAddDevice() {
      this.$router.push({ name: 'device-add' })
    },
    getStatusText(t) {
      let status = this.activeUserInfo.account_role == 0 ? t.status : t.admin_status
      if (status === 1) return 'Active'
      return 'InActive'
    },
    getStatusColor(t) {
      let status = this.activeUserInfo.account_role == 0 ? t.status : t.admin_status
      if (status === 1) return 'success'
      return 'warning'
    },
    getInvertStatusColor(status) {
      if (status === 1) return 'warning'
      return 'success'
    },
    updateDeviceStatus(data) {
      const payload = {
        serial_no: data.serial_no,
        device_status: data.status === 1 ? 0 : 1,
        tag: data.tag,
        update: 1,
      }
      this.$vs.loading()
      this.$store.dispatch('devices/addUpdateDevices', { payload })
        .then((data) => {
          this.$vs.loading.close()
        })
        .catch((error) => {
          this.$vs.loading.close()
          let msg = ''
          try {
            try {
              msg = error.data.message
            } catch (e) {
              msg = error.response.data.message
            }
          } catch (e) {
            msg = ''
          }
          this.$vs.notify({
            position: 'top-center',
            title: 'Error',
            text: msg,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          })
        })
    },
    listPageChanged(item) {
      this.fetchDevices(this.cPage - 1)
    },
    fetchDevices(page = '0') {
      const payload = {}
      if (this.customer != null) {
        payload.customer_id = this.customer.customer_id
      }
      this.$vs.loading()
      return this.$store.dispatch('devices/fetchDevices', { page, payload })
        .then((data) => {
          this.$vs.loading.close()
        })
        .catch((error) => {
          this.$vs.loading.close()
          let msg = ''
          try {
            try {
              msg = error.data.message
            } catch (e) {
              msg = error.response.data.message
            }
          } catch (e) {
            msg = ''
          }
          this.$vs.notify({
            position: 'top-center',
            title: 'Error',
            text: msg,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          })
        })
    },
  },
  mounted() {
    // this.fetchDevices()
  },
}
</script>

<style scoped>

</style>
